import { BannerParamId } from 'app/modules/settings/domain/valueObject/BannerParamId';
import { BannerParamKey } from 'app/modules/settings/domain/valueObject/BannerParamKey';
import { BannerParamValue } from 'app/modules/settings/domain/valueObject/BannerParamValue';

export class BannerParam {

    private readonly _id: BannerParamId;
    private readonly _key: BannerParamKey;
    private readonly _value: BannerParamValue;

    public constructor(
        id: BannerParamId,
        key: BannerParamKey,
        value: BannerParamValue,
    ) {
        this._id = id;
        this._key = key;
        this._value = value;
    }

    public get id(): BannerParamId {
        return this._id;
    }

    public get key(): BannerParamKey {
        return this._key;
    }

    public get value(): BannerParamValue {
        return this._value;
    }

}
